module.exports = __webpack_public_path__ + "img/facebook_number_en.16b67a86.svg";